import React, { ReactNode } from 'react';
import Container from 'react-bootstrap/Container';
import Header from 'layout/Header';

interface LayoutProps {
  children: ReactNode;
  pageTitle: string;
}

const Layout: React.FC<LayoutProps> = ({ children, pageTitle }) => {
  return (
    <>
      <Header pageTitle={pageTitle} />
      <Container>
        <main>{children}</main>
      </Container>
    </>
  );
};

export default Layout;
